module.exports = __webpack_public_path__ + "static/img/wb_ewm.7d195df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wb_ewm.jpg
// module id = +Y6B
// module chunks = 1